import { Card, CardContent, Typography, Box, Button, List, ListItem, ListItemIcon, ListItemText } from "@mui/material"
import Rocket from '../../img/dashboardImg/rocket.svg'
import Video from '../../img/dashboardImg/video.png'

export default function MusicPromotionsCard() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: "100%",
          borderRadius: 3,
          backgroundColor: "#FFFFFF",
        }}
      >
        <CardContent sx={{ padding: "24px !important" }}>
          {/* Header */}
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: "18px",
              color: "#333333",
              marginBottom: 3,
              lineHeight: 1.3,
            }}
          >
            Our Music Promotions tools
          </Typography>

          <List sx={{ padding: 0, marginBottom: 2 }}>
            <ListItem
              sx={{
                padding: "12px 16px",
                backgroundColor: "#f8f6ff",
                borderRadius: 2,
                marginBottom: 1.5,
                border: "1px solid #e8e4ff",
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Box
                  sx={{
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={Rocket} alt="rocket" style={{ width: 20, height: 20 }} />
                </Box>
              </ListItemIcon>
              <ListItemText
                primary="Google Ads"
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333333",
                }}
              />
            </ListItem>

            {/* Reels Promotions */}
            <ListItem
              sx={{
                padding: "12px 16px",
                backgroundColor: "#f8f6ff",
                borderRadius: 2,
                marginBottom: 2,
                border: "1px solid #e8e4ff",
              }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}>
                <Box
                  sx={{
                    borderRadius: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                   <img src={Video} alt="video" style={{ width: 20, height: 20 , color:'#4318FF' }} />
                </Box>
              </ListItemIcon>
              <ListItemText
                primary="Reels Promotions"
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#333333",
                }}
              />
            </ListItem>

             <ListItem
              sx={{
                padding: "12px 16px",
                backgroundColor: "#f8f6ff",
                borderRadius: 2,
                marginBottom: 2,
                border: "1px solid #e8e4ff",
              }}
            >
              <ListItemText
                primary=" Coming Soon"
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontSize: "14px",
                  color: "#999999",
                }}
              />
            </ListItem>
          </List>

          
          {/* Contact Button */}
          <a href="https://api.whatsapp.com/send?phone=918126430111" target="_blank" style={{textDecoration:"none"}}>
            <Button
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#ED3237",
              color: "white",
              fontWeight: 600,
              fontSize: "14px",
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              padding: "12px 24px",
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(231, 76, 60, 0.3)",
              "&:hover": {
                backgroundColor: "#ED3237",
                boxShadow: "0 4px 12px rgba(231, 76, 60, 0.4)",
              },
            }}
          >
            Contact Now
          </Button>
          </a>
        </CardContent>
      </Card>
    </Box>
  )
}
